import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxScrollViewComponent,
  DxTextBoxComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {
  TIPI_PROPRIETA_ARTICOLO_LIST,
  TIPO_PROPRIETA_ARTICOLO_DATA,
  TIPO_PROPRIETA_ARTICOLO_SELMULTI,
} from 'src/app/consts/tipi-proprieta-articolo';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { confirm } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-popup-proprieta-tipologia',
  templateUrl: './popup-proprieta-tipologia.component.html',
  styleUrls: ['./popup-proprieta-tipologia.component.scss'],
  imports: [
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxTextBoxComponent,
    DxLookupComponent,
    DxScrollViewComponent,
    DxCheckBoxComponent,
    DxNumberBoxComponent,
  ],
  standalone: true,
})
export class PopupProprietaTipologiaComponent implements OnInit {
  private tipiArticoliService = inject(TipiArticoliService);

  @Input() tipologiaArticoli: TipiArticoli;
  @Output() popupProprietaTipologiaEventEmitter =
    new EventEmitter<TipiArticoli>();

  readonly listTipiProps = TIPI_PROPRIETA_ARTICOLO_LIST;
  readonly TIPO_PROPRIETA_ARTICOLO_DATA = TIPO_PROPRIETA_ARTICOLO_DATA;
  readonly TIPO_PROPRIETA_ARTICOLO_SELMULTI = TIPO_PROPRIETA_ARTICOLO_SELMULTI;
  props: any[];
  loadPanelVisible = false;
  newValueMultiTracker: string[] = [];

  ngOnInit() {
    if (this.tipologiaArticoli.propJSON) {
      this.props = JSON.parse(this.tipologiaArticoli.propJSON);
    } else {
      this.props = [];
    }
  }

  onEsciClick() {
    this.popupProprietaTipologiaEventEmitter.emit(null);
  }

  onSalvaClick(exit) {
    const names = this.props.map(function (item) {
      return item.nome;
    });
    const findDuplicates = names.some(
      (item, index) => names.indexOf(item) !== index,
    );
    if (findDuplicates) {
      notify('Nomi di proprietà duplicati non validi', 'warning');
    } else {
      this.tipologiaArticoli.propJSON = JSON.stringify(this.props);
      this.loadPanelVisible = true;
      this.tipiArticoliService
        .update(this.tipologiaArticoli.id, this.tipologiaArticoli)
        .subscribe({
          next: (res) => {
            this.tipiArticoliService.getListTipiArticoliTemp(true).subscribe();
            this.loadPanelVisible = false;
            notify('Modello proprietà aggiuntive aggiornato', 'success');
            if (exit) {
              this.popupProprietaTipologiaEventEmitter.emit(res);
            }
          },
          error: (error) => {
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore aggiornamento proprietà', 'error');
            }
          },
        });
    }
  }

  onAggiungiProprietaClick() {
    const newProp = {
      nome: 'nuova',
      tipo: 1,
      obbligatorio: false,
      controlloNotifica: {
        attivo: false,
        giorniPreAlert: 0,
      },
      selMultiplaDati: [],
    };
    this.props.push(newProp);
  }

  onRemoveProprietaClick(prop) {
    const result = confirm('Vuoi rimuovere questa proprietà', 'Rimuovi');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.props = this.props.filter((p) => p !== prop);
      }
    });
    this.newValueMultiTracker = [];
  }

  onAddValueMulti(prop, index) {
    if (
      !this.newValueMultiTracker ||
      !this.newValueMultiTracker[index] ||
      this.newValueMultiTracker[index].trim() == ''
    ) {
      notify('Valore non valido', 'warning');
      return;
    } else if (
      prop.selMultiplaDati.find((m) => m == this.newValueMultiTracker[index])
    ) {
      notify('Valore già presente', 'warning');
      return;
    } else {
      prop.selMultiplaDati.push(this.newValueMultiTracker[index]);
      this.newValueMultiTracker[index] = '';
    }
  }

  onRemoveValoreMulti(val, prop) {
    prop.selMultiplaDati = prop.selMultiplaDati.filter((m) => m !== val);
  }
}

export class PopupProprietaTipologiaModule {}
